import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText, Link
} from "@mui/material";
import { Home, Policy, Menu, Person, Campaign, Telegram } from "@mui/icons-material";
import logo from "../images/logo.jpg";
import "./Header.css"; // Import the CSS file

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate(); // Hook for navigation

  // Toggle Mobile Drawer Menu
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // Function to navigate to different pages
  const handleNavigation = (path) => {
    navigate(path);
    setMobileOpen(false); // Close drawer on mobile after clicking a menu item
  };

  return (
    <AppBar position="static" className="header">
      <Toolbar className="toolbar">
        {/* Logo Section */}
        <Box className="logo-box" onClick={() => handleNavigation("/")}>
          <img src={logo} alt="YONO VIP" className="logo" />
          <Typography variant="h6" className="logo-text">All Yono Looter</Typography>
        </Box>

        {/* Navigation Links (Hidden in Mobile) */}
        <Box className="nav-links">
          <Button color="inherit" startIcon={<Home />} onClick={() => handleNavigation("/")}>
            Home
          </Button>
          <Button color="inherit" startIcon={<Person />} onClick={() => handleNavigation("/about")}>
            About
          </Button>
          <Button color="inherit" startIcon={<Campaign />} onClick={() => handleNavigation("/contact")}>
            Contact Us
          </Button>
          <Button color="inherit" startIcon={<Policy />} onClick={() => handleNavigation("/disclaimer")}>
            Disclaimer
          </Button>
        </Box>

        {/* Right Section: Join Button & Menu Icon */}
        <Box className="action-box">
          <Button variant="contained" className="join-btn" >
            <Telegram className="telegram-icon" />
            <Link
              href="https://t.me/+p13ygJQmED5iYzE9"
              target="_blank"
              rel="noopener noreferrer"
              className="telegram-text"
              underline="none"
              id="telegramLink"
            >
              Join
            </Link>
          </Button>

          {/* Mobile Menu Icon */}
          <IconButton color="inherit" className="menu-icon" onClick={handleDrawerToggle}>
            <Menu />
          </IconButton>
        </Box>
      </Toolbar>

      {/* Mobile Drawer Menu */}
      <Drawer anchor="right" open={mobileOpen} onClose={handleDrawerToggle}>
        <List className="mobile-menu">
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleNavigation("/")}>
              <Home style={{ marginRight: 10 }} />
              <ListItemText primary="Home" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleNavigation("/about")}>
              <Person style={{ marginRight: 10 }} />
              <ListItemText primary="About" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleNavigation("/contact")}>
              <Campaign style={{ marginRight: 10 }} />
              <ListItemText primary="Contact Us" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleNavigation("/disclaimer")}>
              <Policy style={{ marginRight: 10 }} />
              <ListItemText primary="Disclaimer" />
            </ListItemButton>
          </ListItem>
        </List>
      </Drawer>
    </AppBar>
  );
};

export default Header;
